module.exports = __webpack_public_path__ + "a17d279f/img/settings-icon.121d9519.svg";